import { render } from "./PaymentChannel.vue?vue&type=template&id=71530484&scoped=true"
import script from "./PaymentChannel.vue?vue&type=script&lang=js"
export * from "./PaymentChannel.vue?vue&type=script&lang=js"

import "./PaymentChannel.vue?vue&type=style&index=0&id=71530484&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/shugutong/yxLink/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71530484"]])

export default __exports__